import { useRef, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import MenuIcon from "@material-ui/icons/Menu";
import { HiOutlineShoppingBag } from "react-icons/hi";
import config from "../../../../utils/config";
import useScreen from "../../../../providers/screen";
import CartService from "../../../../services/cart/Cart";
import Disabled from "../../../../components/disabled";
import Drawer from "./drawer";
import "./styles/header.css";
import logoHeader from "../../../../assets/images/logoHead.png";

const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    // marginRight: theme.spacing(2),
    zIndex: 20000,
  },
  headerTitle: {
    display: "none",
    [theme.breakpoints.up("xs")]: {
      display: "block",
      fontSize: "15px",
    },
  },
  headerLeft: {
    display: "none",
    [theme.breakpoints.up("xs")]: {
      display: "flex",
    },
  },
  headerCenter: {
    display: "none",
    [theme.breakpoints.up("xs")]: {
      display: "flex",
      justifyContent: "center",
      position: "absolute",
      right: 0,
      left: 0,
    },
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("xs")]: {
      display: "none",
    },
  },
}));

const Header = ({ theme, carts, settings, showIcon }) => {
  const classes = useStyles();

  const { screen } = useScreen();

  const [drawer, setDrawer] = useState(false);

  let history = useHistory();

  const appDisabled = useRef();

  const showCart = () => {
    // if (settings?.restaurant_status && settings?.services) {
    if (settings?.restaurant_status) {
      onChangeRoute("/carts");
    } else {
      appDisabled.current.changeStatus();
    }
  };

  const onChangeRoute = (route, e, data) => {
    if (e) {
      e.preventDefault();
    }

    history.push(route, data);
  };

  return (
    <>
      <Disabled refrence={appDisabled} />
      <Drawer drawer={drawer} drawerChange={setDrawer} position={"right"} />
      <div className={classes.grow}>
        <AppBar
          className={`${screen?.isDesktop && "header-web"}`}
          position="fixed"
        >
          <Toolbar className={`headerContainer ${theme.isDarkTheme && "dark"}`}>
            {showIcon ? (
              <IconButton
                edge="start"
                className={classes.menuButton}
                color="inherit"
                aria-label="open drawer"
                onClick={() => setDrawer(true)}
              >
                <MenuIcon />
              </IconButton>
            ) : (
              <></>
            )}
            <Typography className={classes.headerTitle} variant="h6" noWrap>
              {config.title}
            </Typography>
            <div className={classes.grow} />
            <div className={classes.headerCenter}>
              <img src={logoHeader} height="50" alt="" />
            </div>
            <div className={classes.headerLeft}>
              {CartService.getCartLength(carts) ? (
                <span className="badge badge-danger badge-header-card">
                  {CartService.getCartLength(carts)}
                </span>
              ) : (
                false
              )}

              {showIcon ? (
                <IconButton
                  edge="end"
                  aria-label="account of current user"
                  aria-haspopup="true"
                  onClick={showCart}
                  color="inherit"
                >
                  <HiOutlineShoppingBag />
                </IconButton>
              ) : (
                <></>
              )}
            </div>
          </Toolbar>
        </AppBar>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    theme: state.theme,
    carts: state.carts?.carts,
    settings: state.settings?.settings,
  };
};

export default connect(mapStateToProps, false)(Header);
